export const dropShadowTemplate = {
  color: { light: '#00000029' },
  radius: 6,
  x: 0,
  y: 3,
};
